import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiSprite from "slotworks/graphics/elements/flexi-sprite";
import { Services } from "slotworks/services/services";

export default class SoundToggleComponent {

    private onButton: FlexiButton;
    private offButton: FlexiButton;

    private loadingSprite: FlexiSprite;

    private muted: boolean;

    constructor(onButton: FlexiButton, offButton: FlexiButton, loadingSprite?: FlexiSprite) {
        this.onButton = onButton;
        this.offButton = offButton;

        this.onButton.on(ButtonEvent.CLICK, this.soundOnHandler);
        this.offButton.on(ButtonEvent.CLICK, this.soundOffHandler);

        this.loadingSprite = loadingSprite;
        if (this.loadingSprite) {
            this.loadingSprite.setVisible(false);
        }

        Services.sound.onMuteChange.add(this.setMute);

        this.setMute(Services.sound.getMuted());
    }

    public destroy() {
        this.onButton.off(ButtonEvent.CLICK, this.soundOnHandler);
        this.offButton.off(ButtonEvent.CLICK, this.soundOffHandler);

        Services.sound.onMuteChange.remove(this.setMute);
        Services.sound.onLoadComplete.remove(this.loadComplete);
    }

    public setEnabled(enabled: boolean) {
        this.onButton.setEnabled(enabled);
        this.offButton.setEnabled(enabled);
    }

    public setVisible(visible: boolean) {
        if (visible) {
            this.updateSoundButtons();
        } else {
            this.loadingSprite.setVisible(false);

            this.onButton.setVisible(false);
            this.onButton.setEnabled(false);

            this.offButton.setVisible(false);
            this.offButton.setEnabled(false);
        }
    }

    private soundOnHandler = () => {
        this.setMute(false);
    }

    private soundOffHandler = () => {
        this.setMute(true);
    }

    private setMute = (muted: boolean) => {

        this.muted = muted;

        if (this.muted) {
            Services.sound.mute();
        } else {
            Services.sound.unmute();
        }

        this.updateSoundButtons();
    }

    private loadComplete = () => {
        if (this.loadingSprite) {
            this.loadingSprite.setVisible(false);
        }

        Services.sound.onLoadComplete.remove(this.loadComplete);
        this.setMute(false);
    }

    private updateSoundButtons() {
        this.offButton.setVisible(!this.muted);
        this.offButton.setEnabled(!this.muted);

        this.onButton.setVisible(this.muted);
        this.onButton.setEnabled(this.muted);

        this.waitForSoundsToLoad();
    }

    private waitForSoundsToLoad() {
        if (Services.sound.getLoading()) {
            this.onButton.setVisible(false);
            this.onButton.setEnabled(false);
            this.offButton.setVisible(false);
            this.offButton.setEnabled(false);

            if (this.loadingSprite) {
                this.loadingSprite.setVisible(true);
            }

            Services.sound.onLoadComplete.add(this.loadComplete);
        }
    }

}
